import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core'
import { SlickCarouselComponent } from 'ngx-slick-carousel'
import { ILicense, ILicenseBulkDiscount, LicenseBtnNameType } from '../../../Interface/license'
import { SsrService } from '../../../services/ssr.service'

@Component({
  selector: 'bmcore-license-slider',
  templateUrl: './bmcore-license-slider.component.html',
  styleUrls: ['../bmcore-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLicenseSliderComponent implements OnInit, OnChanges {
  @Input() licenses: ILicense[] = []
  @Input() licenseBulkDiscounts: ILicenseBulkDiscount[] = []
  @Input() btnInLicenseName: LicenseBtnNameType
  @Input() toBeatListBtnRoute: string

  @ViewChild('slickModal') slickModal: SlickCarouselComponent

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: '<div class="nav-btn  next-slide  theme-licenses__arrows">&#10093;</div>',
    prevArrow: '<div class="nav-btn  prev-slide  theme-licenses__arrows">&#10092;</div>',
    dots: true,
    customPaging() {
      return '<div class="pager__item  theme-licenses__dots"></div>'
    },
    infinite: false,
    speed: 500,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          dots: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  }

  constructor(private ssrService: SsrService) {}

  ngOnInit(): void {
    this.ssrService.isRehydratedSubject.subscribe(isRehydrated => {
      if (isRehydrated) {
        this.slickModal?.unslick()
        this.slickModal?.initSlick()
      }
    })
  }

  ngOnChanges() {
    switch (this.licenses.length) {
      case 3: {
        this.changeVisibleDots(2)
        break
      }
      case 2: {
        this.changeVisibleDots(3)
        break
      }
      case 1: {
        this.changeVisibleDots(4)
        break
      }
    }
  }

  // Массив slideConfig.responsive состоит из 4 breakpoints
  // и в зависимости от длиннны массива мы определяем когда показывать точки
  changeVisibleDots(iterationCount: number) {
    for (let i = 0; i < iterationCount; i++) {
      const el = this.slideConfig.responsive[i]
      el.settings.dots = false
    }
  }
}
